import Splide from "@splidejs/splide";

const messageSlider = new Splide('.recruit-message__slider', {
  type: 'fade',
  speed: 3000,
  pagination: false,
  arrows: false,
  autoplay: true,
  interval: 6000,
  pauseOnFocus: false,
  rewind: true,
});

messageSlider.mount();

// インタビューの処理
const interviewMainWrapper = document.querySelectorAll('.interview__main-content > li');
const interviewContentWrapper = document.querySelectorAll('.interview__main-content > li .interview-content');
const interviewTextWrapper = document.querySelectorAll('.interview__main-content > li .interview-content .text-wrapper');
const interviewInnerImage = document.querySelectorAll('.interview__main-content > li .interview-content .image');
const interviewToggleButtons = document.querySelectorAll('.interview__main-content > li .interview-toggle');

interviewToggleButtons.forEach((button, key) => {
  button.addEventListener('click', (element) => {
    // 対象のインタビューを含む li を取得
    const mainWrapper = interviewMainWrapper[key];
    // 対象のインタビューを内包する interview-content を取得
    const contentWrapper = interviewContentWrapper[key];
    // 対象インタビューのコンテンツの高さを取得
    const interviewTextHeight = interviewTextWrapper[key].scrollHeight;
    // 対象インタビューの画像の高さを取得
    const interviewImageHeight = interviewInnerImage[key].scrollHeight;
    // 対象インタビューのコンテンツの高さを取得
    const contentHeight = () => {
      if (window.innerWidth > 960) {
        return interviewTextHeight;
      } else {
        return interviewTextHeight + interviewImageHeight;
      }
    };
    // contentWrapper に active を付与するメソッド
    const addClassActive = () => {
      contentWrapper.classList.add('active');
      contentWrapper.removeEventListener('transitionend', addClassActive);
    }

    if (!interviewToggleButtons[key].classList.contains('active')) {
      interviewToggleButtons[key].classList.add('active');
      // ボタンのテキストを「閉じる」に変更
      interviewToggleButtons[key].lastElementChild.innerHTML = '閉じる';
      // メインのラッパーに active を追加
      mainWrapper.classList.add('active');
      // コンテンツを内包しているラッパーに高さを付与
      contentWrapper.style.height = `${contentHeight()}px`;
      // contentWrapperの変化が完了したら active を付ける
      contentWrapper.addEventListener('transitionend', addClassActive);
    } else {
      interviewToggleButtons[key].classList.remove('active');
      interviewToggleButtons[key].lastElementChild.innerHTML = '詳しく見る';
      mainWrapper.classList.remove('active');
      contentWrapper.style.height = 0;
      contentWrapper.classList.remove('active');
    }
  });
});
